import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Container,
  Paper,
  CircularProgress
} from '@mui/material';
import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '../../utils/usePageTitle';
import './Login.css';

const Login = () => {
  usePageTitle('Login');
  const { isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  /*const handleLogin = async () => {
    setIsLoading(true);
    try {
      await login();
    } catch (error) {
      setIsLoading(false);
    }
  }; */

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      // Sign out any existing session first
      await signOut();
      
      await signInWithRedirect({
        provider: {
          custom: 'ADFS-IDP',
        },
      });
    } catch (error) {
      console.error('Login redirect failed:', error);
      setIsLoading(false);
    }
  };


  return (
    <div className="sony-login-container">
      <div className="sony-background-overlay" aria-hidden="true"></div>
      <Container maxWidth="sm" className="sony-login-content">
        <Paper 
          elevation={0} 
          className="sony-login-card"
          component="main"
          role="main"
          aria-labelledby="login-title"
        >
          <Box className="sony-login-header">
            <Typography 
              variant="h3" 
              className="sony-brand-title"
              id="login-title"
              component="h1"
            >
              CARSON
            </Typography>
            <Typography 
              variant="subtitle1" 
              className="sony-brand-subtitle"
              component="p"
            >
              Quality Assurance Department
            </Typography>
          </Box>
          
          <Box className="sony-login-body">
            {isLoading ? (
              <Box className="sony-loading-section" role="status" aria-live="polite" aria-atomic="true">
                <CircularProgress 
                  size={40} 
                  className="sony-progress" 
                  aria-label="Loading authentication"
                />
                <Typography variant="body1" className="sony-loading-text">
                  Connecting to secure authentication...
                </Typography>
              </Box>
            ) : (
              <>
                <Typography variant="body1" className="sony-welcome-text" id="login-description">
                  Sign in with your Sony credentials to access the Carson Quality Assurance system
                </Typography>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleLogin}
                  className="sony-login-button"
                  size="large"
                  aria-describedby="login-description"
                  aria-label="Sign in with Sony credentials"
                >
                  Sign In
                </Button>
              </>
            )}
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default Login;